import { Text, TextProps } from '@mantine/core';
import { ReactNode } from 'react';

type props = TextProps & {
  children?: ReactNode;
};

const StyledInputErrorText = ({ children, ...props }: props) => {
  if (!children) {
    return <></>;
  }
  return (
    <Text
      c={'var(--mantine-color-error)'}
      size={'11px'}
      classNames={
        {
          // input: classes.input,
          // label: classes.label,
        }
      }
      mt={'5px'}
      style={{ lineHeight: '1.2' }}
      {...props}
    >
      {children}
    </Text>
  );
};

export default StyledInputErrorText;
